export const WHATSAPP_URL = "https://wa.me/message/XE3IM2IGGU5VE1";
export const WHATSAPP_NUMBER = "";

export const whatsappLink = (text) =>
  WHATSAPP_NUMBER ? `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}` : WHATSAPP_URL;
